import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TListedPlaylist } from '../../types/responses/video';

type TState = {
  pending: boolean;
  loaded: boolean;
  error: boolean;
  data: TListedPlaylist[];
};

const initialState: TState = {
  pending: false,
  loaded: false,
  error: false,
  data: [],
};

const viewedSlice = createSlice({
  name: 'playlist/viewed',
  initialState: initialState,
  reducers: {
    viewedPlaylistStartAction: (state) => {
      state.pending = true;
      state.loaded = false;
      state.error = false;
    },
    viewedPlaylistEndAction: (
      state,
      action: PayloadAction<TListedPlaylist[]>
    ) => {
      state.pending = false;
      state.loaded = true;
      state.error = false;
      state.data = action.payload;
    },
    viewedPlaylistErrorAction: (state) => {
      state.pending = false;
      state.loaded = false;
      state.error = true;
    },
  },
});

export const {
  viewedPlaylistStartAction,
  viewedPlaylistErrorAction,
  viewedPlaylistEndAction,
} = viewedSlice.actions;
export const viewedPlaylistReducers = viewedSlice.reducer;
